import React, { useRef, useState } from 'react'
import { API_URL } from '../env'
import '../styles/Contact.css'
import { Fade, Zoom } from 'react-awesome-reveal'
import { faEnvelope, faPaperPlane, faPen, faPhone, faUser } from '@fortawesome/free-solid-svg-icons'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from './Utils/Button'
import { Link } from 'react-router-dom'
import InputText from './Input/InputText'
import InputTextarea from './Input/InputTextarea'
import InputSwitch from './Input/InputSwitch'
import { BrowserView, MobileView } from 'react-device-detect'
import axios from 'axios'
import { toast } from 'react-toastify'
import { ThreeCircles } from 'react-loader-spinner'
import { Helmet } from 'react-helmet'

function Contact({ ip }) {

    const [isLoading, setIsLoading] = useState(false)
    const nameRef = useRef(null)
    const [name, setName] = useState("")
    const [nameError, setNameError] = useState(null)
    const phoneRef = useRef(null)
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState(null)
    const emailRef = useRef(null)
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState(null)
    const messageRef = useRef(null)
    const [message, setMessage] = useState("")
    const [messageError, setMessageError] = useState(null)
    const [accept, setAccept] = useState(false)

    function sendContactEmail() {

        setIsLoading(true)
        var error = []
        if (!nameRef.current.nameValidation(name)) {
            error.push("Le nom est incorrect")
        }
        if (!phoneRef.current.phoneValidationOnBlur(phone)) {
            error.push("Le téléphone est incorrect")
        }
        if (!emailRef.current.emailValidationOnBlur(email)) {
            error.push("L'email est incorrect")
        }
        if (!messageRef.current.textValidation(message)) {
            error.push("Le message est incorrect")
        }
        const typeFormat = "Email"
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Envois...")
            axios.post(API_URL + "contact", {
                type: typeFormat,
                name: name,
                phone: phone,
                email: email,
                message: message,
                ip: ip
            }).then((response) => {
                if (response.data === "CONTACT_SEND") {
                    toast.update(toastId, { render: "Demande de contact envoyée", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    setName("")
                    setNameError(null)
                    setPhone("")
                    setPhoneError(null)
                    setEmail("")
                    setEmailError(null)
                    setMessage("")
                    setMessageError(null)
                    setAccept(false)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CONTACT_CREATION" || errorMessage === "ERROR_UPDATE_CONTACT") {
                        errorMessage = "Erreur lors de la création du message"
                    } else if (errorMessage === "ERROR_SENDING_EMAIL") {
                        errorMessage = "Erreur lors de l'envoi du message"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <>
            <Helmet>
                <meta name="title" content="Contact - E5M Diagnostics" />
                <meta name="description" content="Contactez E5M Diagnostics pour des services de diagnostic de qualité." />
                <meta property="og:title" content="Contact - E5M Diagnostics" />
                <meta property="og:description" content="Contactez E5M Diagnostics pour des services de diagnostic de qualité." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/contact" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/contact" />
            </Helmet>

            <BrowserView>
                <div id='contact'>
                    <div id='contactHeaderBackground' className='headerBackground'>
                        <Fade direction={'down'} duration={500}>
                            <div id='headerFilter'>
                                <h1 id='headerFilterTitle'>Contact</h1>
                            </div>
                        </Fade>
                    </div>
                    <Row id='contactCards'>
                        <Col>
                            <Zoom duration={500}>
                                <div className='contactCard'>
                                    <FontAwesomeIcon icon={faEnvelope} id='contactCardIcon1' />
                                    <div className='contactCardTitle'>contact@e5mdiagnostics.fr</div>
                                    <Button
                                        theme={'dark'}
                                        icon={<FontAwesomeIcon icon={faEnvelope} />}
                                        text={"Envoyer un email"}
                                        rounded={true}
                                        onClick={() => {
                                            const contactForm = document.getElementById('contactForm');
                                            if (contactForm) {
                                                const y = contactForm.getBoundingClientRect().top + window.pageYOffset - 200;
                                                window.scrollTo({ top: y, behavior: 'smooth' });
                                            }
                                        }}
                                    />
                                </div>
                            </Zoom>
                        </Col>
                        <Col>
                            <Zoom duration={500} delay={100}>
                                <div className='contactCard'>
                                    <FontAwesomeIcon icon={faPhone} id='contactCardIcon2' />
                                    <div className='contactCardTitle'>06 58 80 21 34</div>
                                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">Appeller</Link>} rounded={true} />
                                </div>
                            </Zoom>
                        </Col>
                    </Row>
                    <div id='contactMap'>
                        <Zoom duration={500}>
                            <div>
                                <div id='contactMapTitle'>
                                    4 Rue Pierre Brossolette
                                    <br />
                                    92700 Colombes
                                </div>
                                <iframe
                                    title='E5M Diagnostics'
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d671298.8605195078!2d1.4699131106124372!3d48.91041609326542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x606bbd1ea1d00dff%3A0x9e0e53e2f2180b50!2sE5M%20Diagnostics!5e0!3m2!1sfr!2sus!4v1732802423088!5m2!1sfr!2sus"
                                    style={{ width: "100%", height: "600px", border: "0", borderRadius: "10px", boxShadow: "0 0 5px 0 var(--shadow)" }}
                                    allowFullScreen={true}
                                    loading={"lazy"}
                                    referrerPolicy={"no-referrer-when-downgrade"}>
                                </iframe>
                            </div>
                        </Zoom>
                    </div>
                    <Row>
                        <Col sm={5}>
                            <Fade direction={'left'} duration={500}>
                                <div className='contactTitle'>Nous contacter</div>
                                <div className='contactText'>
                                    Contactez l’entreprise E5M Diagnostics pour des services de diagnostic de qualité. Experts en évaluation et en certification, nous sommes là pour répondre à vos besoins en matière de diagnostics immobiliers. Faites confiance à notre équipe
                                    expérimentée pour des solutions fiables et professionnelles.
                                </div>
                                <div className='contactText'>
                                    Contactez-nous dès aujourd’hui pour discuter de vos besoins et bénéficiez de nos services de diagnostic exceptionnels.
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={7}>
                            <div id='contactForm'>
                                <Fade direction={'left'} duration={500}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'dark'}
                                                ref={nameRef}
                                                text={name} setText={setName}
                                                textError={nameError} setTextError={setNameError}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                placeholder={"Nom"}
                                                maxLength={32}
                                                onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                        <Col>
                                            <InputText
                                                type={'phone'}
                                                theme={'dark'}
                                                ref={phoneRef}
                                                text={phone} setText={setPhone}
                                                textError={phoneError} setTextError={setPhoneError}
                                                icon={<FontAwesomeIcon icon={faPhone} />}
                                                placeholder={"Téléphone"}
                                                maxLength={14}
                                                onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={50}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'email'}
                                                theme={'dark'}
                                                ref={emailRef}
                                                text={email} setText={setEmail}
                                                textError={emailError} setTextError={setEmailError}
                                                icon={<FontAwesomeIcon icon={faEnvelope} />}
                                                placeholder={"Email"}
                                                maxLength={128}
                                                onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={100}>
                                    <Row>
                                        <Col>
                                            <InputTextarea
                                                theme={'dark'}
                                                ref={messageRef}
                                                text={message} setText={setMessage}
                                                textError={messageError} setTextError={setMessageError}
                                                icon={<FontAwesomeIcon icon={faPen} />}
                                                placeholder={"Message"}
                                                nbRow={6}
                                                onPressEnter={() => setAccept(true)}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={150}>
                                    <Row>
                                        <Col>
                                            <InputSwitch
                                                theme={'dark'}
                                                value={accept} setValue={setAccept}
                                                label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={200}>
                                    <div id='contactFormButton'>
                                        {!isLoading ?
                                            <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPaperPlane} />} text={"Envoyer"} rounded={true} disabled={!accept} onClick={() => sendContactEmail()} />
                                            :
                                            <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                        }
                                    </div>
                                </Fade>
                            </div>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='contact'>
                    <div id='contactHeaderBackground' className='headerBackground'>
                        <Fade direction={'down'} duration={500}>
                            <div id='headerFilterMobile'>
                                <h1 id='headerFilterTitleMobile'>Contact</h1>
                            </div>
                        </Fade>
                    </div>
                    <div id='contactCards'>
                        <Zoom duration={500}>
                            <div className='contactCardMobile'>
                                <FontAwesomeIcon icon={faEnvelope} id='contactCardIcon1' />
                                <div className='contactCardTitleMobile'>contact@e5mdiagnostics.fr</div>
                                <Button
                                    theme={'dark'}
                                    icon={<FontAwesomeIcon icon={faEnvelope} />}
                                    text={"Envoyer un email"}
                                    rounded={true}
                                    onClick={() => {
                                        const contactForm = document.getElementById('contactFormMobileContainer');
                                        if (contactForm) {
                                            const y = contactForm.getBoundingClientRect().top + window.pageYOffset - 120;
                                            window.scrollTo({ top: y, behavior: 'smooth' });
                                        }
                                    }}
                                />
                            </div>
                        </Zoom>
                        <Zoom duration={500} delay={100}>
                            <div className='contactCardMobile'>
                                <FontAwesomeIcon icon={faPhone} id='contactCardIcon2' />
                                <div className='contactCardTitleMobile'>06 58 80 21 34</div>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">Appeller</Link>} rounded={true} />
                            </div>
                        </Zoom>
                    </div>
                    <div id='contactMapMobile'>
                        <Zoom duration={500}>
                            <div>
                                <div id='contactMapTitle'>
                                    4 Rue Pierre Brossolette
                                    <br />
                                    92700 Colombes
                                </div>
                                <iframe
                                    title='E5M Diagnostics'
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d671298.8605195078!2d1.4699131106124372!3d48.91041609326542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x606bbd1ea1d00dff%3A0x9e0e53e2f2180b50!2sE5M%20Diagnostics!5e0!3m2!1sfr!2sus!4v1732802423088!5m2!1sfr!2sus"
                                    style={{ width: "100%", height: "400px", border: "0", borderRadius: "10px", boxShadow: "0 0 5px 0 var(--shadow)" }}
                                    allowFullScreen={true}
                                    loading={"lazy"}
                                    referrerPolicy={"no-referrer-when-downgrade"}>
                                </iframe>
                            </div>
                        </Zoom>
                    </div>
                    <div id='contactFormMobileContainer'>
                        <Fade direction={'left'} duration={500}>
                            <div className='contactTitleMobile'>Nous contacter</div>
                            <div className='contactTextMobile'>
                                Contactez l’entreprise E5M Diagnostics pour des services de diagnostic de qualité. Experts en évaluation et en certification, nous sommes là pour répondre à vos besoins en matière de diagnostics immobiliers. Faites confiance à notre équipe
                                expérimentée pour des solutions fiables et professionnelles.
                            </div>
                            <div className='contactTextMobile'>
                                Contactez-nous dès aujourd’hui pour discuter de vos besoins et bénéficiez de nos services de diagnostic exceptionnels.
                            </div>
                        </Fade>
                    </div>
                    <div id='contactFormMobile'>
                        <Fade direction={'left'} duration={500}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'name'}
                                        theme={'dark'}
                                        ref={nameRef}
                                        text={name} setText={setName}
                                        textError={nameError} setTextError={setNameError}
                                        icon={<FontAwesomeIcon icon={faUser} />}
                                        placeholder={"Nom"}
                                        maxLength={32}
                                        onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={50}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'phone'}
                                        theme={'dark'}
                                        ref={phoneRef}
                                        text={phone} setText={setPhone}
                                        textError={phoneError} setTextError={setPhoneError}
                                        icon={<FontAwesomeIcon icon={faPhone} />}
                                        placeholder={"Téléphone"}
                                        maxLength={14}
                                        onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <Row>
                                <Col>
                                    <InputText
                                        type={'email'}
                                        theme={'dark'}
                                        ref={emailRef}
                                        text={email} setText={setEmail}
                                        textError={emailError} setTextError={setEmailError}
                                        icon={<FontAwesomeIcon icon={faEnvelope} />}
                                        placeholder={"Email"}
                                        maxLength={128}
                                        onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={150}>
                            <Row>
                                <Col>
                                    <InputTextarea
                                        theme={'dark'}
                                        ref={messageRef}
                                        text={message} setText={setMessage}
                                        textError={messageError} setTextError={setMessageError}
                                        icon={<FontAwesomeIcon icon={faPen} />}
                                        placeholder={"Message"}
                                        nbRow={6}
                                        onPressEnter={() => setAccept(true)}
                                    />
                                </Col>
                            </Row>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={200}>
                            <InputSwitch
                                theme={'dark'}
                                value={accept} setValue={setAccept}
                                label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                            />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={250}>
                            <div id='contactFormButton'>
                                {!isLoading ?
                                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPaperPlane} />} text={"Envoyer"} rounded={true} disabled={!accept} onClick={() => sendContactEmail()} />
                                    :
                                    <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                }
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default Contact